import React, { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import BulkImport from "./BulkImport/BulkImport";
import HeaderFilter from "../AddBuyer/HeaderFilter/HeaderFilter";
import BuyerTable from "./BuyerTable/BuyerTable";
import Pagination from "./Pagination/Pagination";
import Buttons from "./Pagination/Buttons";
import BulkUpload from "./BulkExport/BulkUpload";
import All_Active_Buyer from "./All_Active_Buyer_Table";

// const  AllData = [
//   {
//     "email": "alpha@example.com",
//     "mobile": "9894120477",
//     "buyer_status": "active",
//     "company_id": "B1240",
//     "company_name": "Example Corp",
//     "company_website_url": "https://example.com",
//     "nature_of_business": "Software Development",
//     "company_primary_email_id": "contact@example.com",
//     "company_primary_phone_number": "0987654321",
//     "tax_id": "1234567899",
//     "preferred_currency": "USD",
//     "type_of_company": "LLC",
//     "year_of_incorporation": 2010,
//     "company_contact_number": "5551234567",
//     "country": "USA",
//     "state": "California",
//     "city": "San Francisco",
//     "buyer_added_date": "2025-02-03T10:00:00Z",  // Optional since auto_now_add is set
//     "buyer_source": "Referral",
//     "buyer_stage": "Lead",
//     "age":26,
//     "attachment":"zmmSoW.pdf",
//     "assignment": {
//         "admin_emails": ["sure12@gmail.com"],
//         "priority": "High",
//         "comments": "Urgent delivery required",
//         "completed_on": "2023-12-31"
//     }

// }
// ]

const AllActiveBuyer = ({message, Hidden, HiddenForTrash, Heading }) => {
  const BASE_URL = process.env.REACT_APP_API_URLS;

  // Dropdown state and ref
  const dropdownRef = useRef(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);

  // Generic search state
  const [searchCriteria, setSearchCriteria] = useState({});

  // Pagination and data state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [data, setData] = useState([]); // Initialize as empty array
  const [selectedRows, setSelectedRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true); // Add loading state
  const [error, setError] = useState(null); // Add error state

  // Fetch data from API
  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const url = `${BASE_URL}/addbuyer/buyer-details/?page=${currentPage}&rows=${rowsPerPage}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      
      const result = await response.json();
      setData(result.results || []); // Ensure data is an array
      setCount(result.count || 0);
      // setData(AllData)
      // setCount(20)
    } catch (error) {
      setError(error.message); // Set error state
      setData([]); // Fallback to empty array
    } finally {
      setLoading(false); // End loading
    }
  };

  // Pagination handlers
  const handleNext = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Row selection handlers
  const handleSelectAll = () => {
    setSelectedRows((prevSelected) =>
      prevSelected.length === data.length ? [] : data.map((row) => row.id)
    );
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id]
    );
  };

  // Generic search handler
  const handleSearchChange = (field, value) => {
    setSearchCriteria((prevCriteria) => ({
      ...prevCriteria,
      [field]: value,
    }));
  };

  // Filter data based on search criteria
  const filteredData = data.filter((row) => {
    return Object.keys(searchCriteria).every((field) => {
      const searchValue = searchCriteria[field];
      if (!searchValue) return true; // If no search value, include the row
      return String(row[field])
        .toLowerCase()
        .includes(searchValue.toLowerCase());
    });
  });

  // Pagination logic
  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setIsSelectOpen(false);
        setIsMenuOpen(false);
        setIsActionOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Status class logic
  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "bg-[#e1fcef] text-[#38a06c]";
      case "Deactive":
        return "bg-[#ffedef] text-[#d12a3e]";
      case "On Hold":
        return "bg-[#e9edf5] text-[#5a6376]";
      case "Premium":
        return "bg-[#fcf2e6] text-[#c97a20]";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Render loading or error state
  if (loading) {
    return (
      <div className="flex my-28 justify-center items-center">
        <div className="flex flex-row gap-2">
          <div className="w-4 h-4 rounded-full bg-red-500 animate-bounce" />
          <div className="w-4 h-4 rounded-full bg-red-500 animate-bounce [animation-delay:-.2s]" />
          <div className="w-4 h-4 rounded-full bg-red-500 animate-bounce [animation-delay:-.4s]" />
        </div>
      </div>
    );
  }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  const handleDeleteSelected = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/buyers-list/buyers/bulk-delete/`,
        {
          method: "delete",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyer_ids: selectedRows, // Send the selected buyer IDs
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete selected buyers");
      }

      // If the API call is successful, update the local state
      setData((prevData) =>
        prevData.filter((row) => !selectedRows.includes(row.id))
      );
      setSelectedRows([]); // Clear the selected rows after deletion
    } catch (error) {
      setError("Failed to delete selected buyers. Please try again.");
    }
  };

  return (
    // <div className=" w-full">
    //   <div className="overflow-x-auto w-full">
    //     <div
    //       className={`${
    //         Hidden ? "hidden" : "flex"
    //       } items-center justify-between px-2`}
    //     >
    //       <h1 className="text-[#667085] text-xl font-medium">
    //         {Heading ? "Trash" : "All Buyers"}
    //       </h1>
    //       <div className="flex items-center gap-3 p-2">
    //         <div className={HiddenForTrash}>
    //           <BulkUpload />
    //         </div>
    //         <BulkImport />
    //         <div>
    //           <Buttons
    //             rowsPerPage={rowsPerPage}
    //             setRowsPerPage={setRowsPerPage}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //     <div className="overflow-hidden rounded-lg border-2 border-gray-200 w-full">
    //       <HeaderFilter
    //         searchCriteria={searchCriteria}
    //         handleSearchChange={handleSearchChange}
    //         dropdownRef={dropdownRef}
    //         Hidden={Hidden}
    //         isFilterOpen={isFilterOpen}
    //         setIsFilterOpen={setIsFilterOpen}
    //         isSelectOpen={isSelectOpen}
    //         setIsSelectOpen={setIsSelectOpen}
    //         isMenuOpen={isMenuOpen}
    //         setIsMenuOpen={setIsMenuOpen}
    //         isActionOpen={isActionOpen}
    //         setIsActionOpen={setIsActionOpen}
    //         selectedRows={selectedRows}
    //         handleDeleteSelected={handleDeleteSelected}
    //       />

    //       <BuyerTable
    //         currentData={currentData}
    //         selectedRows={selectedRows}
    //         handleRowSelect={handleRowSelect}
    //         selectAll={selectedRows.length === data.length}
    //         handleSelectAll={handleSelectAll}
    //         searchCriteria={searchCriteria}
    //         handleSearchChange={handleSearchChange}
    //         getStatusClass={getStatusClass}
    //       />
    //       <Outlet />
    //     </div>
    //     <div className={`${Hidden ? "hidden" : ""} mt-2`}>
    //       <Pagination
    //         currentPage={currentPage}
    //         rowsPerPage={rowsPerPage}
    //         count={filteredData.length}
    //         onNext={handleNext}
    //         onPrevious={handlePrevious}
    //       />
    //     </div>
    //   </div>
    // </div>
    <div className="w-[80vw]">
    <All_Active_Buyer message={message} Heading={Heading}/>
    </div>
  );
};

export default AllActiveBuyer;
